module.exports = __webpack_public_path__ + "img/logo-gio.40b8a04f.png";